import { AmpImage, AmpImageParams } from "types/amplience";
import { Brand } from "types/common";
import { BRAND_IMAGE_HOSTS_MAP, DEFAULT_IMAGE_HOST } from "./consts";

export const buildImageHost = (host: string, brand: Brand) => {
  if (host !== DEFAULT_IMAGE_HOST) return host;
  return BRAND_IMAGE_HOSTS_MAP[brand] || host;
};

const buildImageURL = (image: AmpImage, { brand, ...params }: { brand: Brand } & AmpImageParams): string => {
  const imageHost = buildImageHost(image.defaultHost, brand);

  const url = new URL(`/i/${image.endpoint}/${image.name}`, `https://${imageHost}`);
  Object.entries(params).forEach(([key, value]) => url.searchParams.set(key, value.toString()));

  return url.toString();
};

export default buildImageURL;
